// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorMessage_root__1i-iT","inner":"ErrorMessage_inner__2sUtl"};